import React from 'react';

const KPIS = [
  { key: 'total',   filter: 'all',     label: 'Total',   tone: 'total',   sub: 'Tracked devices' },
  { key: 'online',  filter: 'online',  label: 'Online',  tone: 'online',  sub: 'Reporting now' },
  { key: 'idle',    filter: 'idle',    label: 'Idle',    tone: 'idle',    sub: 'No movement 2h+' },
  { key: 'offline', filter: 'offline', label: 'Offline', tone: 'offline', sub: 'No signal 24h+' },
];

export default function MapKpiStrip({ counts, fleetTotal, isScoped = false, panelVisible, activeFilter, onFilterChange }) {
  return (
    <div className="dm-kpi-strip">
      {KPIS.map(k => {
        const isActive = activeFilter === k.filter;
        // When a batch / location / search narrows the fleet, the TOTAL tile says so
        // explicitly rather than silently showing a smaller number than last time.
        const sub = k.key === 'total' && isScoped
          ? `Of ${fleetTotal} tracked`
          : k.sub;
        return (
          <button
            key={k.key}
            type="button"
            className={`card dm-kpi-card${isActive ? ' active' : ''}${isScoped ? ' scoped' : ''}`}
            onClick={() => onFilterChange(isActive ? 'all' : k.filter)}
            aria-pressed={isActive}
          >
            <div className="dm-kpi-label">{k.label}</div>
            <div className={`dm-kpi-value tone-${k.tone}`}>{counts[k.key]}</div>
            <div className="dm-kpi-sub">{sub}</div>
          </button>
        );
      })}
    </div>
  );
}
